import {Component} from "@angular/core";

@Component({
  selector: "app-head-content",
  template: "<ng-content></ng-content>",
  styleUrls: ["./head-content.component.scss"]
})
export class HeadContentComponent {}
